import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import { UTextField } from "@/components/index"
import { UButton } from "@/components/index"
export const UndercutFill = () => {
  const {
    clinicalSettings: { UnderCut },
  } = useAppSelector((state: RootState) => state.userService)
  const dispatch = useAppDispatch()
  // checkbox if No UnderCut
  const [checkNoUnder, setCheckNoUnder] = useState<boolean>(false)
  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckNoUnder(event.target.checked)
  }
  useEffect(() => {
    setCheckNoUnder(UnderCut === 1 ? true : false)
  }, [])
  return (
    <Box sx={{ width: "100%" }}>
      <FormControlLabel
        control={<Checkbox checked={checkNoUnder} onChange={handleCheck} />}
        label="Do not add undercut filling(digital waxing)"
        sx={{ margin: "0 0 10px 0" }}
      />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "150px",
        }}
      >
        <UButton
          sxProp={{
            color: "#212121",
            height: "36px",
            width: "176px",
            borderRadius: "4px",
            background: "#DADCDD !important",
            boxShadow:
              "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)",
            padding: "6px 16px",
          }}
          variant={"contained"}
          btnText={`undercut Preview`}
        />
      </Box>
    </Box>
  )
}
